import { Ajax } from '../../Ajax/Ajax.js';
import { popupManager } from '../../_VROC/PopupManager.js';

export class Dashboard {
	constructor() {
		this.ajax = new Ajax();
	}

	/**
	 * Загружает детали задачи и показывает их в попапе
	 * @param {number} taskId - ID задачи
	 */
	async loadTaskDetails(taskId) {
		try {
			console.log('[Dashboard] Загрузка деталей задачи:', taskId);

			// Отправляем AJAX запрос для получения деталей задачи
			const response = await this.ajax.post('/ajax.php?mid=2', {
				action: 'getTaskDetails',
				taskId: taskId
			}, {
				dataType: 'html'
			});

			$('.dashboard__task-container').replaceWith(response);
			$('.dashboard__task-container').addClass('active');

			// Заменяем содержимое попапа
			/*const popup = document.querySelector('.dashboard__task-container');
			if (popup) {
				popup.outerHTML = response;

				// Привязываем события к новому попапу
				const newPopup = document.querySelector('.dashboard__task-container');
				if (newPopup) {
					this.bindEvents(newPopup);

					// Открываем попап через менеджер попапов
					popupManager.open('popup-task'); // ???
				}
			}*/

			console.log('[Dashboard] Детали задачи загружены успешно');
		} catch (error) {
			console.error('[Dashboard] Ошибка загрузки деталей задачи:', error);
			alert('Ошибка при загрузке информации о задаче: ' + error.message);
		}
	}

	/**
	 * Отмечает задачу как выполненную
	 * @param {number} taskId - ID задачи
	 */
	async completeTask(taskId) {
		try {
			console.log('[Dashboard] Отметка задачи как выполненной:', taskId);

			await this.ajax.post('/ajax.php?mid=2', {
				action: 'completeTask',
				taskId: taskId
			});

			console.log('[Dashboard] Задача отмечена как выполненная');

			// Закрываем попап
			popupManager.closeAll();

			// Перезагружаем страницу для обновления списка задач
			location.reload();

		} catch (error) {
			console.error('[Dashboard] Ошибка при отметке задачи:', error);
			alert('Ошибка при отметке задачи: ' + error.message);
		}
	}

	/**
	 * Привязывает события к загруженному контенту
	 * @param {HTMLElement} container - контейнер с загруженным контентом
	 */
	bindEvents(container) {
		// Привязываем попапы через PopupManager
		popupManager.bindPopupEvents(container);

		console.log('[Dashboard] События привязаны к контейнеру');
	}
}
